import React from "react"
import { Container, Row, Col } from "@bootstrap-styled/v4"
import { StaticQuery, graphql } from "gatsby"
import { Element } from "react-scroll"
import WOW from "react-wow"

import ContactForm from "./ContactForm"
import Footer from "src/components/sections/Footer"
import Button from "src/components/ui/Button"
import icons from "./icons"

import * as S from "./styled"

const Contact = ({ variant }) => {
  const IconInstagram = icons["Instagram"]
  const IconLinkedin = icons["Linkedin"]
  const IconWhatsapp = icons["Whatsapp"]

  return (
    <StaticQuery
      query={graphql`
        query {
          bgImage: file(relativePath: { eq: "backgrounds/bg-footer.png" }) {
            childImageSharp {
              fluid(maxWidth: 1400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          topBg: file(relativePath: { eq: "backgrounds/fluid-top-1.png" }) {
            childImageSharp {
              fluid(maxWidth: 1400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          content: allMarkdownRemark(
            filter: { fileAbsolutePath: { regex: "/(dados_gerais)/" } }
          ) {
            nodes {
              frontmatter {
                url_linkedin
                url_instagram
                url_whatsapp
                email
                telefone
              }
            }
          }
        }
      `}
      render={data => (
        <Element name="section-contato">
          <S.ContactWrapper
            Tag="section"
            fluid={data.bgImage.childImageSharp.fluid}
          >
            <S.CurveTop fluid={data.topBg.childImageSharp.fluid} />
            <S.ContactContent>
              <Container>
                {variant === "sm" ? (
                  <Row>
                    <WOW animation="fadeInLeft">
                      <Col lg={6}>
                        <S.ContactCaption variant={`sm`}>
                          <S.ContactTitle variant={`sm`}>
                            {`Quer evoluir sua ideia?`}
                          </S.ContactTitle>
                          <S.ContactButton
                            target="_blank"
                            href={
                              data.content.nodes[0].frontmatter.url_whatsapp
                            }
                          >
                            <Button
                              color="green"
                              size="lg"
                              hasIcon="Whatsapp"
                            >{`Faça um orçamento`}</Button>
                          </S.ContactButton>
                        </S.ContactCaption>
                      </Col>
                    </WOW>
                    <WOW animation="fadeInUp">
                      <Col lg={6}>
                        <S.ContactCaption>
                          <S.ContactSubTitle>
                            {`E-mail / WhatsApp`}
                          </S.ContactSubTitle>
                          <S.ContactMethods>
                            <S.ContactLink
                              href={`mailto:${data.content.nodes[0].frontmatter.email}`}
                            >
                              {data.content.nodes[0].frontmatter.email}
                            </S.ContactLink>
                            <S.ContactLink
                              href={
                                data.content.nodes[0].frontmatter.url_whatsapp
                              }
                            >
                              {data.content.nodes[0].frontmatter.telefone}
                            </S.ContactLink>
                          </S.ContactMethods>
                          <S.ContactSubTitle>
                            {`Redes Sociais`}
                          </S.ContactSubTitle>
                          <S.ContactSocial>
                            <li>
                              <S.ContactSocialLink
                                title="Instagram"
                                target="_blank"
                                href={
                                  data.content.nodes[0].frontmatter
                                    .url_instagram
                                }
                              >
                                <IconInstagram />
                              </S.ContactSocialLink>
                            </li>
                            <li>
                              <S.ContactSocialLink
                                title="Whatsapp"
                                target="_blank"
                                href={
                                  data.content.nodes[0].frontmatter.url_whatsapp
                                }
                              >
                                <IconWhatsapp />
                              </S.ContactSocialLink>
                            </li>
                            <li>
                              <S.ContactSocialLink
                                title="Linkedin"
                                target="_blank"
                                href={
                                  data.content.nodes[0].frontmatter.url_linkedin
                                }
                              >
                                <IconLinkedin />
                              </S.ContactSocialLink>
                            </li>
                          </S.ContactSocial>
                        </S.ContactCaption>
                      </Col>
                    </WOW>
                  </Row>
                ) : (
                  <Row>
                    <WOW animation="fadeInLeft">
                      <Col lg={6}>
                        <ContactForm />
                      </Col>
                    </WOW>
                    <WOW animation="fadeInUp">
                      <Col lg={6}>
                        <S.ContactCaption>
                          <S.ContactTitle>
                            {`Quer evoluir sua ideia?`}
                          </S.ContactTitle>
                          <S.ContactParagraph>
                            {`Chama a gente! Nossa equipe está só esperando por você. 🚀`}
                          </S.ContactParagraph>
                          <S.ContactButton
                            target="_blank"
                            href={
                              data.content.nodes[0].frontmatter.url_whatsapp
                            }
                          >
                            <Button
                              color="green"
                              size="lg"
                              hasIcon="Whatsapp"
                            >{`Contato por Whatsapp`}</Button>
                          </S.ContactButton>
                          <S.ContactSubTitle>
                            {`E-mail / WhatsApp`}
                          </S.ContactSubTitle>
                          <S.ContactMethods>
                            <S.ContactLink
                              target="_blank"
                              href={`mailto:${data.content.nodes[0].frontmatter.email}`}
                            >
                              {data.content.nodes[0].frontmatter.email}
                            </S.ContactLink>
                            <S.ContactLink
                              target="_blank"
                              href={
                                data.content.nodes[0].frontmatter.url_whatsapp
                              }
                            >
                              {data.content.nodes[0].frontmatter.telefone}
                            </S.ContactLink>
                          </S.ContactMethods>
                          <S.ContactSubTitle>
                            {`Redes Sociais`}
                          </S.ContactSubTitle>
                          <S.ContactSocial>
                            <li>
                              <S.ContactSocialLink
                                title="Instagram"
                                target="_blank"
                                href={
                                  data.content.nodes[0].frontmatter
                                    .url_instagram
                                }
                              >
                                <IconInstagram />
                              </S.ContactSocialLink>
                            </li>
                            <li>
                              <S.ContactSocialLink
                                title="Whatsapp"
                                target="_blank"
                                href={
                                  data.content.nodes[0].frontmatter.url_whatsapp
                                }
                              >
                                <IconWhatsapp />
                              </S.ContactSocialLink>
                            </li>
                            <li>
                              <S.ContactSocialLink
                                title="Linkedin"
                                target="_blank"
                                href={
                                  data.content.nodes[0].frontmatter.url_linkedin
                                }
                              >
                                <IconLinkedin />
                              </S.ContactSocialLink>
                            </li>
                          </S.ContactSocial>
                        </S.ContactCaption>
                      </Col>
                    </WOW>
                  </Row>
                )}
              </Container>
            </S.ContactContent>
            <Footer />
          </S.ContactWrapper>
        </Element>
      )}
    />
  )
}

export default Contact
